<div>
  <div class="projects">
    <div *ngIf="showSpinner" class="progress-spinner">
      <mat-spinner></mat-spinner>
    </div>
    <h1 class="project-title">PROJEKTE</h1>
    <div class="content-page">
      <div class="courses" *ngFor="let project of pagedList">
        <div class="example-card" routerLink="{{ project.id }}">
          <div class="logoTitle">
            <div class="logo-content-title">
              <div *ngIf="project.showLogo">
                <img
                  mat-card-image
                  src="{{ project.project_icon_url }}"
                  alt="{{ project.title }}"
                  [style.display]="project.project_icon_url === 'https://res.cloudinary.com/dyekwrvwe/image/upload/v1709258959/placeholder_b3miif.jpg' ? 'none' : 'block'"
                />
              </div>
              <div class="titleDiv">
                {{ project.title }}
                <div class="toolTipM">
                  {{ project.fullTitle }}
                </div>
              </div>
            </div>
            <div>
              <div class="location">
                <div class="location-title">
                  Wann: {{ project.start_date | date }} -
                  {{ project.end_date | date }}
                </div>
                <div class="location-title">Wo: {{ project.location }}</div>
              </div>
            </div>
          </div>
          <div class="proj-content-img" *ngIf="project.showProjectImage">
            <!-- *ngIf="showProjectImage" -->
          </div>
          <div [ngClass]="{ 'no-image': project.project_image_url === '' }">
            <p class="proj-content">
              {{ project.content }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <mat-paginator
      class="custom-mat-paginator"
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
      (page)="OnPageChange($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
</div>
